<div [formGroup]="formGroup" class="company-name-container" fxLayoutGap="6px" fxLayout="row" fxLayoutAlign="center center">
  <mat-form-field fxFlex="auto" class="company-name-container__company-name-field">
    <input matInput autocomplete="off" placeholder="Team name" [formControlName]="controlName" />
  </mat-form-field>
  <span class="company-name-container__appended-text">.{{ appUrlEnding }}</span>
</div>
